import {
  Center,
  Column,
  CustomSpinner,
  FloatingContainer,
  Pagination,
  Screen,
  Text,
} from '~/commonComponents';
import {
  IDraftJobPostListViewEntity,
  IJobPostEntity,
  JobPostingStatus,
} from '~/domain/PermanentJobs';
import { DefaultTable, DraftTable, Header, SuspendedBanner } from './components';
import { useManageJobs } from './useManageJobs';

export const ManageJobs = () => {
  const {
    data, forms, initialStatus, isInitialLoading,
    isLoading, methods, pagination, statistics,
  } = useManageJobs();

  const isDraft = forms.filters.status === JobPostingStatus.Draft;

  return (
    <>
      <Screen>
        <FloatingContainer borderRadius={0} paddingBlock={48} paddingInline={16} height="100%">
          <Text bold fontSize={32} textAlign="center">
            Permanent Jobs
          </Text>
          <SuspendedBanner counts={statistics.tabs.suspended} style={{ marginTop: 24 }} />
          <Header
            initialStatus={initialStatus}
            statistics={statistics.tabs}
            onValueChanges={(newValue) => {
              methods.setFormFilters(newValue);
              methods.setCurrentPage(1);
            }}
          />
          <Column paddingInline={72}>
            {isInitialLoading ? (
              <Center marginBlock={32}>
                <CustomSpinner isLoading size={32} />
              </Center>
            ) : (
              <>
                {!isDraft ? (
                  <DefaultTable
                    data={data as IJobPostEntity[]}
                    formSorting={forms.sorting}
                    isLoading={isLoading}
                    onSortChanges={methods.setFormSorting}
                  />
                ) : (
                  <DraftTable data={data as IDraftJobPostListViewEntity[]} isLoading={isLoading} />
                )}
                <Pagination
                  currentPage={pagination.currentPage}
                  totalPages={pagination.totalPages}
                  onPageChange={methods.setCurrentPage}
                />
              </>
            )}
          </Column>
        </FloatingContainer>
      </Screen>
    </>
  );
};
